import { useRef } from "react";

var useSelfReference = function useSelfReference(reference) {
  var targetReference = useRef(null);
  return [targetReference, function (node) {
    targetReference.current = node;

    if (typeof reference === "function") {
      reference(node);
    } else if (reference) {
      reference.current = node;
    }
  }];
};

export default useSelfReference;